<template>
    <div class="usual-alert" :class="[additionalClass, type]" :style="styles">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: "UsualAlert",
    props: {
        styles: {
            type: Object,
            default: () => {}
        },
        type: {
            type: String,
            default: ""
        },
        additionalClass: [String, Array]
    }
}
</script>

<style lang="sass">
@import 'resources/sass/vars'
.usual-alert
    padding: 10px
    font-size: 14px
    line-height: 160%
    background-color: #f9fbff
    border-radius: 7px
    color: #52565c
    &.mb-14
        margin-bottom: 14px
    strong
        color:  $danger-color !important
    .collapse-container
        transition: grid-template-rows 100ms
    &.mb-20
        margin-bottom: 20px
    &.helping
        background-color: #FFFDF5
        border: 1px solid #F9F1D0
        align-items: center
    &.helping-blue
        background-color: #F1F8FC
        border: 1px solid #B3DBF1
    &.helping-red
        background-color: #FFECEC
        border: 1px solid #FAC9C9
    &.helping-red-light
        background-color: #FFF6F6
        border: 1px solid #FFF6F6
    &.helping-green-light
        background-color: #DCFAEE
        border: 1px solid #DCFAEE
    &.helping-green-light-2
        background-color: $alert-color3
        border: 1px solid $alert-color3
    &.service
        background-color: #FBFCFF
        border: 1px solid #ECF1F5
        color: #98A2B0
    .helping-link
        color: $accent-color7
        border-bottom: 1px solid $accent-color7
    a
        color: #3965FF
        text-decoration: none
        cursor: pointer
        &:hover
            text-decoration: underline
            text-underline-offset: 2px
</style>

<style lang="sass">
@import 'resources/sass/vars'

.warning
    font-weight: 600
    color: $danger-color

.alert
    &__title
        &_warning
            font-weight: 600
            color: $danger-color

.example
    font-weight: 600
    color: $accent-color5
</style>
